import {generateId} from './utilities/'
import moment from 'moment';
const firebase = window.firebase;

const googleProvider = new firebase.auth.GoogleAuthProvider();
const facebookProvider = new firebase.auth.FacebookAuthProvider();

export const auth = firebase.auth();
export const storage = firebase.storage;
export const timestamp = firebase.firestore.Timestamp;
export const firestore = firebase.firestore();


auth.setPersistence(firebase.auth.Auth.Persistence.SESSION)
  .catch(function(error) {
    // Handle Errors here.
    var errorCode = error.code;
    var errorMessage = error.message;
		console.log(errorCode, errorMessage);
  });
// TODO: Move as much of this as possible into the api

export const signInWithGoogle = () => {
  auth.signInWithPopup(googleProvider);
};

export const signInWithFacebook = () => {
  auth.signInWithPopup(facebookProvider);
};

export const generateUserDocument = async (userData) => {
	const user = auth.currentUser;
  if (!(user && user.displayName)) return;
  const userRef = firestore.doc(`users/${user.uid}`);
  const snapshot = await userRef.get();

	const { email, displayName, photoURL } = user;
  if (displayName && !snapshot.exists) {
    try {
      await userRef.set({
				id: generateId(user.uid),
				role: 'pending',
        name: displayName,
        email,
        photoURL
      }, {merge: true});
    } catch (error) {
      throw(error);
    }
  }
  return getUserDocument(user.uid);
};

export const getDocumentData = async (collection, id) => {
	try {
		const doc = await firestore.doc(`${collection}/${id}`).get();
		if (doc.exists) {
			return doc.data();
		}
	} catch (error) {
		throw(error);
	}
};

export const getUserDocument = async uid => {
  if (!uid) return null;
  try {
    const userData = await getDocumentData('users', uid);
		return userData;
  } catch (error) {
    throw(error);
  }
};

const buildCollectionQuery = (collection, query, isCollectionGroup) => {
	let collectionQuery = isCollectionGroup ? firestore.collectionGroup(collection) : firestore.collection(collection);
	if (query) {
		query.where && query.where.forEach(whereQuery => {
			collectionQuery =  collectionQuery.where(...whereQuery);
		});
		if (query.orderBy) {
			collectionQuery = collectionQuery.orderBy(...query.orderBy);
		}
		if (query.startAfter) {
			collectionQuery = collectionQuery.startAfter(query.startAfter);
		}
		if (query.limit) {
			collectionQuery = collectionQuery.limit(query.limit);
		}
	}

	return collectionQuery;
};

export const getCollection = async (collection, query, isCollectionGroup) => {
	const collectionQuery = buildCollectionQuery(collection, query, isCollectionGroup);
	const queryResult = await collectionQuery.get();
	const queryDocs = queryResult.docs.map(doc => doc.data());

	return {
		data: queryDocs,
		lastDocument: queryResult.docs[queryResult.docs.length - 1]
	};
};

export const addDocument = async (collection, data) => {
	const docRef = firestore.collection(collection).doc(data.id);
	return docRef.set(data, {merge: true});
};

export const getAlbum = async id => {
	const album = await firestore.collection('albums').doc(id).get();
	if (album.exists) {
		return album.data();
	}
	throw new Error(`no album found for ${id}`);
};

export const getReview = async id => {
	const reviewsCollection = await getCollection('reviews', {where: [['id', '==', id]]}, true);
	const reviews = reviewsCollection.data;
	if (reviews.length === 1) {
		return reviews[0];
	}
	throw new Error(`no review found for ${id}`);
};

export const getArtistAlbums = async artistId => {
	const query = { where: [['artist.id', '==', artistId]] };
	const artistAlbumsCollection = getCollection('albums', query);
	return artistAlbumsCollection.data;
};

export const getCollectionListener = (collection, query, callback) => {
	const collectionQuery = buildCollectionQuery(collection, query);
	const unsub = collectionQuery.onSnapshot(snapshot => {
		const results = [];
		snapshot.forEach(doc => {
			results.push(doc.data());
		});
		callback(results);
	});
	return unsub;
}

export const getDownloadURL = async filename => {
	const url = await storage()
	  .ref()
	  .child(filename)
	  .getDownloadURL();

	return url;
}

export const updateMetadata = async filename => {
	const imageRef = await storage().ref().child(filename);

	// Create file metadata to update
	var newMetadata = {
	  cacheControl: 'public,max-age=31536000'
	}

	// Update metadata properties
	imageRef.updateMetadata(newMetadata).then(function(metadata) {
	  console.log(metadata);
	}).catch(function(error) {
	  console.log(error);
	});
}

export const saveReview = async (reviewData) => {
	const albumRef = firestore.collection('albums').doc(reviewData.album.id);
	const reviewRef = albumRef.collection('reviews').doc(reviewData.id);
	return await reviewRef.set(reviewData, { merge: true });
}

export function dateToTimestamp(date) {
	return timestamp.fromDate(new Date(date));
}

export function timestampToDateString(time) {
	return moment(time.toDate()).format('MM/DD/YYYY');
}

export const uploadImage = async (file) => {
	const filename = file.name;
	const imageRef = await storage().ref().child(filename);

	return imageRef.put(file).then(async function(snapshot) {
		const downloadURL = await imageRef.getDownloadURL();
		return downloadURL;
	});
};
